import { useState } from "react"

export default function Modal({ titulo, subtitulo, onCerrar, children, ancho }) {
  const [confirmandoCierre, setConfirmandoCierre] = useState(false)
  return (
    <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.75)", zIndex:1000, display:"flex", alignItems:"center", justifyContent:"center", padding:"20px" }} onClick={() => setConfirmandoCierre(true)}>
      <div style={{ position:"relative", background:"#0f0f0f", border:"1px solid #2a2a2a", borderRadius:"16px", width:"100%", maxWidth:ancho||"560px", maxHeight:"90vh", overflow:"hidden", display:"flex", flexDirection:"column" }} onClick={e=>e.stopPropagation()}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", padding:"20px 24px", borderBottom:"1px solid #2a2a2a", flexShrink:0 }}>
          <div>
            <div style={{ fontWeight:800, color:"#e5e7eb", fontSize:"1rem" }}>{titulo}</div>
            {subtitulo&&<div style={{ fontSize:"0.8rem", color:"#6b7280", marginTop:"2px" }}>{subtitulo}</div>}
          </div>
          <button onClick={() => setConfirmandoCierre(true)} style={{ background:"none", border:"none", color:"#6b7280", fontSize:"1.2rem", cursor:"pointer", padding:"4px 8px" }}>✕</button>
        </div>
        <div style={{ overflowY:"auto", padding:"24px", flex:1 }}>{children}</div>
        {confirmandoCierre && (
          <div style={{
            position:"absolute", inset:0, background:"rgba(0,0,0,0.7)",
            display:"flex", alignItems:"center", justifyContent:"center", zIndex:10,
            borderRadius:"16px"
          }}>
            <div style={{ background:"#1a1a1a", border:"1px solid #3a3a3a", borderRadius:"12px", padding:"24px", maxWidth:"300px", textAlign:"center" }}>
              <div style={{ color:"#e5e7eb", fontWeight:700, marginBottom:"8px" }}>¿Salir sin guardar?</div>
              <div style={{ color:"#6b7280", fontSize:"0.85rem", marginBottom:"20px" }}>Los datos cargados se van a perder.</div>
              <div style={{ display:"flex", gap:"10px", justifyContent:"center" }}>
                <button onClick={() => setConfirmandoCierre(false)}
                  style={{ padding:"8px 18px", background:"#2a2a2a", border:"1px solid #3a3a3a", borderRadius:"8px", color:"#9ca3af", cursor:"pointer", fontFamily:"Inter, sans-serif", fontWeight:600 }}>
                  Cancelar
                </button>
                <button onClick={onCerrar}
                  style={{ padding:"8px 18px", background:"#7f1d1d", border:"1px solid #ef444440", borderRadius:"8px", color:"#ef4444", cursor:"pointer", fontFamily:"Inter, sans-serif", fontWeight:700 }}>
                  Salir
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
